import { Redirect } from 'react-router-dom';
import { QuickBooksDashboard } from 'assets/js/pages/account-settings/account-integrations/QuickBooks/QuickBooksDashboard';
import { useQuickBooksStatus } from 'assets/js/pages/account-settings/account-integrations/QuickBooks/useQuickBooksStatus';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const QuickBooksIndex = () => {
    const { accountId } = useCurrentAccount();
    const { data } = useQuickBooksStatus();
    const { status } = data;

    if (!status) {
        return <Redirect to={`/accounts/${accountId}/settings/integrations/quickbooks/connect`} />;
    }

    return <QuickBooksDashboard />;
};

export { QuickBooksIndex };
